export default "__VITE_ASSET__DrSTW8Cn__"